import axios from 'axios';
import LoginService from '../services/LoginService.js'

export default class ReportService {

  getCharts(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/report/api/v1/charts",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  getDashboard(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/report/api/v1/dashboard",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  getReport(filters) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/report/api/v1/report",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

  downloadTable(filters) {
    return axios({
      method: 'post',
      responseType: 'blob',
      url: process.env.VUE_APP_BASE_URL + "/report/api/v1/download/table",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
      data: filters
    })
    .then(res => res)
    .catch(error => {
      console.log(error.response)
      if (error.response.status == 401) {
        let loginService = new LoginService();
        loginService.logout()
      }
      else
        return error.response
    });
  }

}
